import styled, { css, type RuleSet } from "styled-components";

export const StyledDiv = styled.div<{
  specifyMinHeight?: boolean;
}>`
  position: relative;
  ${({ specifyMinHeight }): false | RuleSet =>
    !!specifyMinHeight &&
    css`
      min-height: 20rem;
    `}
`;
